import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as lessonSelectors from '../selectors';
import * as lessonActions from '../actions';
import { STATUS } from '../constants';

export const useChunkVisits = (lessonId) => {
  const dispatch = useDispatch();

  const chunkVisits = useSelector((state) =>
    lessonSelectors.getChunkVisitsByLessonId(state, lessonId)
  );

  const chunkVisitsLoadingStatus = useSelector((state) =>
    lessonSelectors.getChunkVisitsByLessonIdStatus(state, lessonId)
  );

  useEffect(() => {
    if (chunkVisitsLoadingStatus === STATUS.UNINITIALIZED) {
      dispatch(lessonActions.loadChunkVisitsByLessonId.signal(lessonId));
    }
  }, [dispatch, lessonId, chunkVisitsLoadingStatus]);

  return {
    data: chunkVisits,
    isLoading: [STATUS.LOADING, STATUS.SUBMITTING].includes(
      chunkVisitsLoadingStatus
    ),
    error:
      chunkVisitsLoadingStatus === STATUS.ERROR
        ? 'Error loading chunkvisits'
        : null,
    recordChunkVisit: (lessonId, chunkId) => {
      dispatch(lessonActions.recordChunkVisit.signal(lessonId, chunkId));
    },
  };
};
